import React, { createContext, useContext, useState } from 'react'
import ToastContainer from '../components/common/Toast'

// 创建Toast上下文
const ToastContext = createContext()

// Toast提供者组件
export function ToastProvider({ children }) {
	const [toasts, setToasts] = useState([])

	const addToast = (message, type = 'info', duration = 3000) => {
		const id = Date.now() + Math.random()
		const newToast = { id, message, type, duration }
		
		setToasts(prev => [...prev, newToast])
		
		return id
	}

	const removeToast = (id) => {
		setToasts(prev => prev.filter(toast => toast.id !== id))
	}

	const showSuccess = (message, duration) => addToast(message, 'success', duration)
	const showError = (message, duration) => addToast(message, 'error', duration)
	const showWarning = (message, duration) => addToast(message, 'warning', duration)
	const showInfo = (message, duration) => addToast(message, 'info', duration)

	const value = {
		toasts,
		addToast,
		removeToast,
		showSuccess,
		showError,
		showWarning,
		showInfo
	}

	return (
		<ToastContext.Provider value={value}>
			{children}
			<ToastContainer toasts={toasts} removeToast={removeToast} />
		</ToastContext.Provider>
	)
}

// 自定义Hook，用于在组件中使用Toast
export function useToast() {
	const context = useContext(ToastContext)
	if (!context) {
		throw new Error('useToast must be used within a ToastProvider')
	}
	return context
} 